/**
 * Flatten rich-text HTML into a short plain-text summary.
 *
 * Image rows (LocationImage.note, PortfolioImage.note, SiteImage.note) store
 * PLAIN TEXT — ImageGallery renders the field raw into a hover overlay and
 * ImageReviewPopup edits it as a string, so HTML would show the user literal
 * tags. Note rows store the Quill HTML instead. This converts the former from
 * the latter.
 */

const DEFAULT_MAX_LENGTH = 280

const ENTITIES: Record<string, string> = {
	'&nbsp;': ' ',
	'&amp;': '&',
	'&lt;': '<',
	'&gt;': '>',
	'&quot;': '"',
	'&#39;': "'",
	'&apos;': "'",
}

export const htmlToPlainText = (
	html: string | null | undefined,
	maxLength = DEFAULT_MAX_LENGTH,
): string => {
	if (!html) return ''

	const text = html
		// Block boundaries become spaces, so '<p>a</p><p>b</p>' is not 'ab'.
		.replace(/<\/(p|div|li|h[1-6]|blockquote)>/gi, ' ')
		.replace(/<br\s*\/?>/gi, ' ')
		.replace(/<[^>]*>/g, '')
		.replace(/&nbsp;|&amp;|&lt;|&gt;|&quot;|&#39;|&apos;/g, match => ENTITIES[match] ?? match)
		.replace(/\s+/g, ' ')
		.trim()

	if (maxLength > 0 && text.length > maxLength) {
		return `${text.slice(0, maxLength).trimEnd()}…`
	}

	return text
}

export default htmlToPlainText
